import ConferenceLayoutStyleComponent from "../../../containers/components/eucrm-layout-style.component";
import ConferenceHeader from "../../../components/header/grs-header";

type headerBanner = {
  bannerImage: string,
  headerText: string,
  topCommonMesage: string,
  mobileBanner: string
}
const GRSBanner = (props: headerBanner) => {
  return (
    <>
      <ConferenceLayoutStyleComponent />
      <ConferenceHeader />

      <div id="header-image" className="header-image">
        <img src={props.mobileBanner} alt="Event Hero" className="mobile-image" />
        <div className="top-text" dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
      </div>

      <div dangerouslySetInnerHTML={{ __html: props.topCommonMesage }}></div>
      <div className="bottom-text" dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
      <style>
        {`
           @media(min-width: 1024px){
            .header-image{
                background-image: url( ${props.bannerImage});
                background-position: center bottom !important;
            }
          
            }
            @media(min-width: 1024px){
                .mobile-image{
                    display: none;
                }
            }
            @media(max-width: 1024px){
                .top-text{
                    display: none;
                } 
            }
            @media(min-width: 1025px){
                .bottom-text{
                    display: none;
                }
            }
            .head-message {
                text-align: center;
                font-weight: bold;
                color: white;
                background: #4BA33A;
                padding: 13px 0;
                font-size: 132%;
                margin: 0;
            }
            @media(max-width: 768px){
              .head-message { display: none; }
            }
            
        `}
      </style>
    </>
  )
}
export default GRSBanner